define('views/space_switcher/Podio.Views.SpaceSwitcherSearchResultItem',['require','underscore','lib/backbone/Backbone.PodioView','jst!space_switcher/_search_result_item'],function(require) {

  var _ = require('underscore');
  var PodioView = require('lib/backbone/Backbone.PodioView');

  var jstSearchResultItem = require('jst!space_switcher/_search_result_item');

  return PodioView.extend({

    tagName : 'li',

    initialize: function() {
      this._super();
    },

    iconMap: {
      'emp_network': 'icon-24 icon-24-green-employee-network',
      'grants': 'icon-24 icon-24-grant-blue',
      'home': 'icon-24 icon-24-home',
      'contacts': 'icon-24 icon-24-contacts',
      'calendar': 'icon-24 icon-24-calendar',
      'tasks': 'icon-24 icon-24-task',
      'demo': 'icon-24 icon-24-space',
      'space': 'icon-24 icon-24-space',
      'app': function(model) {
        return 'app-icon-24 icon-{0}'.format(model.get('app_icon'));
      }
    },

    getIcon: function(model) {
      var icon = this.iconMap[model.get('type')];
      if (_.isFunction(icon)) {
        icon = icon(model);
      }
      return icon;
    },

    render: function() {
      var html = this.getTemplate(jstSearchResultItem, {
        model: this.model,
        icon: this.getIcon(this.model)
      });

      this.elm.html(html);
    }

  });

});

